(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kieker"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initKieker(root) {
    if (root.dataset.kiekerInit) return;
    root.dataset.kiekerInit = '1';
    var track = root.querySelector('[data-kieker-track]');
    var nav = root.querySelector('[data-kieker-nav]');
    var prev = root.querySelector('[data-kieker-prev]');
    var next = root.querySelector('[data-kieker-next]');
    if (!track || !nav) return;

    function step() {
      var card = track.querySelector('.sve-kieker-card');
      return card ? card.offsetWidth + 20 : 300;
    }
    function updateNav() {
      if (track.scrollWidth > track.clientWidth + 10) {
        nav.hidden = false;
      } else {
        nav.hidden = true;
      }
    }
    if (prev) { prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); }
    if (next) { next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); }
    window.addEventListener('resize', updateNav);
    updateNav();
  }
  function initAll() {
    document.querySelectorAll('[data-kieker]').forEach(initKieker);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-kieker]');
    if (root) { initKieker(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesk = window.matchMedia('(min-width: 861px)');

  function initReels(root) {
    if (root.dataset.reelsInit) return;
    root.dataset.reelsInit = '1';
    var autoplay = root.dataset.autoplay === 'true' && !reduced;
    var row = root.querySelector('[data-reels-row]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-reel]'));
    if (!row || !cards.length) { return; }
    var active = Math.floor((cards.length - 1) / 2);
    var sectionVisible = false;

    function videoOf(card) { return card.querySelector('video'); }
    function play(card) {
      var v = videoOf(card);
      if (!v) { return; }
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
      card.classList.remove('is-paused');
    }
    function pause(card) {
      var v = videoOf(card);
      if (!v) { return; }
      v.pause();
      card.classList.add('is-paused');
    }
    function muteAll() {
      cards.forEach(function (c) {
        var v = videoOf(c);
        if (v) { v.muted = true; }
        c.classList.remove('is-sound');
      });
    }
    function position() {
      if (!mqDesk.matches) { row.style.transform = ''; return; }
      var card = cards[active];
      var target = row.parentElement.clientWidth / 2 - (card.offsetLeft + card.offsetWidth / 2);
      row.style.transform = 'translateX(' + Math.round(target) + 'px)';
    }
    function setActive(i, user) {
      active = i;
      cards.forEach(function (c, idx) {
        if (idx === i) {
          c.classList.add('is-active');
        } else {
          c.classList.remove('is-active');
          pause(c);
          var v = videoOf(c);
          if (v) { v.muted = true; }
          c.classList.remove('is-sound');
        }
      });
      position();
      if ((autoplay && sectionVisible) || user) { play(cards[i]); }
    }

    cards.forEach(function (card, idx) {
      var video = videoOf(card);
      card.classList.add('is-paused');

      card.addEventListener('click', function () {
        if (mqDesk.matches && idx !== active) { setActive(idx, true); }
      });

      if (video) {
        video.addEventListener('click', function () {
          if (mqDesk.matches && idx !== active) { return; }
          if (video.paused) { play(card); } else { pause(card); }
        });
      }

      var playBtn = card.querySelector('[data-reel-play]');
      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (mqDesk.matches && idx !== active) { setActive(idx, true); return; }
          play(card);
        });
      }

      var soundBtn = card.querySelector('[data-reel-sound]');
      if (soundBtn && video) {
        soundBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var wasMuted = video.muted;
          muteAll();
          if (wasMuted) {
            video.muted = false;
            card.classList.add('is-sound');
            soundBtn.setAttribute('aria-label', 'Ton ausschalten');
            if (video.paused) { play(card); }
          } else {
            soundBtn.setAttribute('aria-label', 'Ton einschalten');
          }
        });
      }

      if ('IntersectionObserver' in window && video) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (mqDesk.matches) { return; }
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              if (autoplay) { play(card); }
            } else {
              if (!video.paused) { pause(card); }
              video.muted = true;
              card.classList.remove('is-sound');
            }
          });
        }, { threshold: [0, 0.5] });
        io.observe(card);
      }
    });

    if ('IntersectionObserver' in window) {
      var rootIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sectionVisible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          if (!mqDesk.matches) { return; }
          if (sectionVisible) {
            if (autoplay) { play(cards[active]); }
          } else {
            cards.forEach(pause);
            muteAll();
          }
        });
      }, { threshold: [0, 0.35] });
      rootIo.observe(root);
    } else {
      sectionVisible = true;
    }

    window.addEventListener('resize', position);
    if (mqDesk.addEventListener) {
      mqDesk.addEventListener('change', function () { setActive(active, false); });
    }
    setActive(active, false);
  }

  function initAll() {
    document.querySelectorAll('[data-reels]').forEach(initReels);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-reels]');
    if (root) { initReels(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
